import { render, staticRenderFns } from "./HomeFive.vue?vue&type=template&id=03a143aa&"
import script from "./HomeFive.vue?vue&type=script&lang=js&"
export * from "./HomeFive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports